import React from 'react'

import { AppSvg, Button, FormattedHTMLMessage, newIcons } from '@web/walter-ui-kit'
import { useIntl } from 'react-intl'
import s from './s.module.css'
import { lang } from './lang'
import ModalView from '~components/ModalView'
import { globalLang } from '~globalLang'

interface Props {
    onClose: () => void
}

function Error({ onClose }: Props) {
    const intl = useIntl()

    const supportLink = intl.formatMessage(globalLang.contactSupportLink)

    return (
        <ModalView
            img={
                <div className={s.icon}>
                    <AppSvg svgName={newIcons.ic80CloseCircle} size={80} path="new-icons" />
                </div>
            }
            title={<FormattedHTMLMessage {...lang.title} />}
            subtitle={<FormattedHTMLMessage {...lang.subtitle} />}
            dataPointer="status_error"
        >
            <div className={s.button}>
                <Button dataPointer="cancel" size="l" href={supportLink} role="anchor" fullWidth>
                    <FormattedHTMLMessage {...lang.contact} />
                </Button>
                <Button dataPointer="freeze" size="l" mode="primary" onClick={onClose} fullWidth>
                    <FormattedHTMLMessage {...lang.button} />
                </Button>
            </div>
        </ModalView>
    )
}

export default Error
